import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#FF6C7F" }}>Brief</span>
            </h2>
            <p>
              iRemembered is an app that helps users to schedule their messages
              in advance using one of the pre-defined templates or by
              customizing their unique message.
            </p>
            <h2 style={{ color: "#898989" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#FF6C7F" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#FF6C7F" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#FF6C7F" }}> MOBILE APPLICATION</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
